import { render, staticRenderFns } from "./DefaultProjectSettings.vue?vue&type=template&id=1f3d0010&scoped=true&"
import script from "./DefaultProjectSettings.vue?vue&type=script&lang=js&"
export * from "./DefaultProjectSettings.vue?vue&type=script&lang=js&"
import style0 from "./DefaultProjectSettings.vue?vue&type=style&index=0&id=1f3d0010&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3d0010",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
